import { Link, useParams } from 'react-router-dom'
import { format, parseISO } from 'date-fns'
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers'
import { IsGranted } from '../../../app/modules/auth/PrivateRoute'
import { ROLE, useAuth } from '../../../app/modules/auth'
import { IClientItem } from '../../../app/modules/clients/core/_models'
import { useState } from 'react'
import Swal from 'sweetalert2'
import { Spinner } from 'react-bootstrap'
import { toggleClientRequisite } from '../../../app/modules/settings/api/requisiteClientApi'
import { TruncatedValue } from '../../../app/common/TruncatedValue'

export const ClientItemRequisite = ({
  client,
  active,
  onSuccess,
  chooseClient,
  showFlagColumn,
  setClient,
}: {
  client: IClientItem
  active: boolean
  onSuccess: () => void
  chooseClient?: boolean
  showFlagColumn?: boolean
  setClient?: (client: IClientItem) => void
}) => {
  const [loading, setLoading] = useState(false)
  const { currentUser } = useAuth()
  const params = useParams()

  const handleToggle = async () => {
    if (!client.id || !params.id) return
    setLoading(true)
    try {
      const response = await toggleClientRequisite(params.id, client.id)
      if (!response?.data?.success) {
        throw new Error(
          'errors' in response?.data ? response?.data?.errors?.general_error : 'Unknown error'
        )
      }
      onSuccess()
    } catch(error: any) {
      const errorMessage = error?.data?.errors?.general_error || 
                           error?.data?.message || 
                           error?.message || 
                           'Ошибка отправки запроса. Попробуйте позже'
      Swal.fire(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  return (
    <tr>
      {showFlagColumn && (
        <td>
          <img
            src={toAbsoluteUrl(`/media/flags/${client.color}.svg`)}
            alt=''
            className='w-30px'
          />
        </td>
      )}
      <td>
        {IsGranted(
          [
            ROLE.ROLE_ADMIN,
            ROLE.ROLE_MANAGER,
            ROLE.ROLE_SENIOR_OPERATOR,
            ROLE.ROLE_OPERATOR,
            ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR,
            ROLE.ROLE_MERCHANT_MANAGER,
          ],
          currentUser
        ) ? (
          <Link to={'/client/info/' + client.token} className='text-primary' target='_blank'>
            <TruncatedValue value={client.externalId} focusable={false} />
          </Link>
        ) : (
          <TruncatedValue value={client.externalId} />
        )}
      </td>
      {IsGranted([ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER], currentUser) && (
        <td>{client.merchantTitle || '-'}</td>
      )}
      {IsGranted([ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER], currentUser) && (
        <td className='min-w-350px text-break'>{client.comment}</td>
      )}
      <td>
        {client.lastActivityDate
          ? format(parseISO(client.lastActivityDate), 'dd.MM.yyyy HH:mm')
          : ''}
      </td>
      <td>{format(parseISO(client.createdAt), 'dd.MM.yyyy HH:mm')}</td>
      {chooseClient && (
        <td className='float-right'>
          <button
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 me-4'
            onClick={() => setClient?.(client)}
          >
            <KTIcon className='fs-1' iconName='check-square' />
          </button>
        </td>
      )}
      <td className='cursor-pointer' onClick={handleToggle}>
        {loading ? (
          <Spinner />
        ) : (
          <KTIcon
            className={`fs-1 ${active ? 'text-danger' : 'text-success'}`}
            iconName={active ? 'cross-circle' : 'down-square'}
          />
        )}
      </td>
    </tr>
  )
}
